export default {
    data() {
        return {
            showManualEntryLink: false,
            showManualEntryPopup: false,
            searchVehicleFilled: false,
            isManualEntry: false,
        };
    },
    methods: {
        handleManualEntrySubmitGeneric(data, modelName, modelObj) {
            this[modelName] = { ...this[modelName], ...data };

            // Set manual entry flag
            this.isManualEntry = true;

            // Sync circulation date input if updated in modal
            if (this[modelName].annee_mise_en_circulation &&
                this[modelName].mois_mise_en_circulation &&
                this[modelName].jour_mise_en_circulation) {
                this.circulationDateInput = new Date(
                    this[modelName].annee_mise_en_circulation,
                    this[modelName].mois_mise_en_circulation - 1,
                    this[modelName].jour_mise_en_circulation
                );
            }

            this.showManualEntryPopup = false;
            this.showManualEntryLink = false;
            this.searchVehicleFilled = true;

            // Automatically go to next step
            this.$nextTick(() => {
                if (typeof this.goToNextStep === 'function') {
                    this.goToNextStep();
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/manualVehicleEntry.js